import CentDetailed from "@/images/previews/cent-detailed.png";
import CentSimple from "@/images/previews/cent-simple.png";

import CentColorBlind from "@/images/previews/cent-color-blind.png";
import CentDefault from "@/images/previews/cent-default.png";
import CentInferno from "@/images/previews/cent-inferno.png";
import CentRdYlGn from "@/images/previews/cent-RdYlGn.png";
import CentTurbo from "@/images/previews/cent-turbo.png";
import CentViridis from "@/images/previews/cent-viridis.png";

import SpocColorBlind from "@/images/previews/spoc-color-blind.png";
import SpocPlasma from "@/images/previews/spoc-plasma.png";
import SpocSinebow from "@/images/previews/spoc-sinebow.png";
import SpocTurbo from "@/images/previews/spoc-turbo.png";
import SpocViridis from "@/images/previews/spoc-viridis.png";
import SpocWarm from "@/images/previews/spoc-warm.png";

import ColorBlind from "@/images/schemes/color-blind.png";
import Inferno from "@/images/schemes/inferno.png";
import Plasma from "@/images/schemes/plasma.png";
import RdGn from "@/images/schemes/RdGn.png";
import RdYlGn from "@/images/schemes/RdYlGn.png";
import Sinebow from "@/images/schemes/sinebow.png";
import Turbo from "@/images/schemes/turbo.png";
import Viridis from "@/images/schemes/viridis.png";
import Warm from "@/images/schemes/warm.png";

import a from "@/images/previews/exportChart-0-0-100.png";
import b from "@/images/previews/exportChart-0-0-125.png";
import c from "@/images/previews/exportChart-0-0-150.png";
import d from "@/images/previews/exportChart-0-0-175.png";
import e from "@/images/previews/exportChart-0-0-200.png";
import f from "@/images/previews/exportChart-1-0-100.png";
import g from "@/images/previews/exportChart-1-0-125.png";
import h from "@/images/previews/exportChart-1-0-150.png";
import i from "@/images/previews/exportChart-1-0-175.png";
import j from "@/images/previews/exportChart-1-0-200.png";
import k from "@/images/previews/exportChart-2-0-100.png";
import l from "@/images/previews/exportChart-2-0-125.png";
import m from "@/images/previews/exportChart-2-0-150.png";
import n from "@/images/previews/exportChart-2-0-175.png";
import o from "@/images/previews/exportChart-2-0-200.png";

import {
    EChartAspectRatio,
    EChartFontSize,
    EDataColorSchemes,
    EDetailedFingerprint,
} from "@/components/preferences/models";

// https://git.lum-gmbh.de/lum/sepview/web/-/wikis/Architecture/Preferences-preview-files

export function getCentDetailImage(value: EDetailedFingerprint) {
    return value === EDetailedFingerprint.Detailed ? CentDetailed : CentSimple;
}

export function getCentColorImage(scheme: EDataColorSchemes) {
    switch (scheme) {
        case EDataColorSchemes.ColorBlind:
            return CentColorBlind;

        case EDataColorSchemes.Inferno:
            return CentInferno;

        case EDataColorSchemes.RdYlGn:
            return CentRdYlGn;

        case EDataColorSchemes.Turbo:
            return CentTurbo;

        case EDataColorSchemes.Viridis:
            return CentViridis;

        case EDataColorSchemes.RdGn:
        default:
            return CentDefault;
    }
}

export function getSpocColorImage(scheme: EDataColorSchemes) {
    switch (scheme) {
        case EDataColorSchemes.ColorBlind:
            return SpocColorBlind;

        case EDataColorSchemes.Plasma:
            return SpocPlasma;

        case EDataColorSchemes.Sinebow:
            return SpocSinebow;

        case EDataColorSchemes.Turbo:
            return SpocTurbo;

        case EDataColorSchemes.Viridis:
            return SpocViridis;

        case EDataColorSchemes.Warm:
            return SpocWarm;
    }
}

export function getSchemeImage(scheme: EDataColorSchemes) {
    switch (scheme) {
        case EDataColorSchemes.ColorBlind:
            return ColorBlind;

        case EDataColorSchemes.RdGn:
            return RdGn;

        case EDataColorSchemes.Inferno:
            return Inferno;

        case EDataColorSchemes.RdYlGn:
            return RdYlGn;

        case EDataColorSchemes.Turbo:
            return Turbo;

        case EDataColorSchemes.Viridis:
            return Viridis;

        case EDataColorSchemes.Warm:
            return Warm;

        case EDataColorSchemes.Plasma:
            return Plasma;

        case EDataColorSchemes.Sinebow:
            return Sinebow;
    }
}

export function getChartExportImage(
    chartAspectRatio: EChartAspectRatio,
    chartFontSize: EChartFontSize,
) {
    const _ = [a, b, c, d, e, f, g, h, i, j, k, l, m, n, o]; // need to be kept there, for imports
    const ratio =
        chartAspectRatio === EChartAspectRatio.Screen
            ? EChartAspectRatio.Ratio4to3
            : chartAspectRatio; // fallback for screen to 4:3

    return `assets/exportChart-${ratio}-0-${chartFontSize}.png`;
}
